export enum PhoneType {
    Mobil = 1,
    Fix = 2,
    Professional = 3,
    Fax = 4
}
